/* istanbul ignore file */

const menu = (
  <svg
    width="20px"
    height="16px"
    viewBox="0 0 20 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Menu</title>
    <g
      id="Navigation"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="1.Mobile_Navigation_Closed"
        transform="translate(-25.000000, -27.000000)"
        stroke="#00222C"
        strokeWidth="1.3"
      >
        <g id="Group-14" transform="translate(20.000000, 20.000000)">
          <line
            x1="6.202375"
            y1="21.96275"
            x2="24.034875"
            y2="21.96275"
            id="Stroke-11"
          ></line>
          <line
            x1="6.202375"
            y1="15.010875"
            x2="24.034875"
            y2="15.010875"
            id="Stroke-12"
          ></line>
          <line
            x1="6.202375"
            y1="8.060125"
            x2="24.034875"
            y2="8.060125"
            id="Stroke-13"
          ></line>
        </g>
      </g>
    </g>
  </svg>
);

export default menu;
